export default __webpack_public_path__ + "static/media/logo1.87505747.svg";